import styled from 'styled-components';
const TextCenter = styled.div `
  text-align: center;
  color: #fff;
`;
export const Root = styled(TextCenter) `
  width: 100%;
  height: 100%;
  background-color: #000537;
  .ant-btn {
    display: block;
    margin: auto;
    width: 3.84rem;
    height: 0.64rem;
    color: #fff;
    border-radius: 8px;
    font-size: 0.28rem;
  }
  .btn_simulate {
    margin-top: 0.64rem;
    background-color: #ff9900;
    border-color: #ff9900;
  }
  .btn_formal {
    margin-top: 0.4rem;
    background-color: #1dbf6e;
    border-color: #1dbf6e;
  }
`;
export const Top = styled.div `
  padding-top: 0.64rem;
  font-size: 0.24rem;
`;
export const Time = styled.div `
  margin-top: 0.16rem;
  font-size: 0.4rem;
  color: #ffc745;
`;
export const Content = styled.div `
  margin-top: 0.8rem;
  font-size: 0.36rem;
`;
